__turbopack_context__.v({
  "container": "product-configuration-visid-module-scss-module__3Z0Lzq__container",
  "description": "product-configuration-visid-module-scss-module__3Z0Lzq__description",
  "image": "product-configuration-visid-module-scss-module__3Z0Lzq__image",
  "image-container": "product-configuration-visid-module-scss-module__3Z0Lzq__image-container",
  "image-non-selected": "product-configuration-visid-module-scss-module__3Z0Lzq__image-non-selected",
  "image-opacity": "product-configuration-visid-module-scss-module__3Z0Lzq__image-opacity",
  "label-container": "product-configuration-visid-module-scss-module__3Z0Lzq__label-container",
  "loading-image": "product-configuration-visid-module-scss-module__3Z0Lzq__loading-image",
  "main-product-container": "product-configuration-visid-module-scss-module__3Z0Lzq__main-product-container",
  "options": "product-configuration-visid-module-scss-module__3Z0Lzq__options",
  "options-column-container": "product-configuration-visid-module-scss-module__3Z0Lzq__options-column-container",
  "options-disabled": "product-configuration-visid-module-scss-module__3Z0Lzq__options-disabled",
  "products-options-container": "product-configuration-visid-module-scss-module__3Z0Lzq__products-options-container",
  "title": "product-configuration-visid-module-scss-module__3Z0Lzq__title",
});
